<template>
    <div class="coupon_wrapper">
        <div v-if="show_loading_page" class="page_loading_screen">
            <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
        <div v-if="!show_loading_page" class="bkgd_canvas">
            <div v-bind:class="{'long_form': !user_logged_in&&show_create_account_fields}" class="bkgd_red_section">
                <img v-bind:class="{'long_form': !user_logged_in&&show_create_account_fields}" class="phone_img" src="https://assets.realclear.com/images/59/592529_5_.png" alt="iPhone SE showing Real Clear Politics Homepage" 
                srcset="https://assets.realclear.com/images/59/592529_1_.png 163w,
                        https://assets.realclear.com/images/59/592529_2_.png 109w,
                        https://assets.realclear.com/images/59/592529_3_.png 49w,
                        https://assets.realclear.com/images/59/592529_4_.png 174w,
                        https://assets.realclear.com/images/59/592529_5_.png 326w,
                        https://assets.realclear.com/images/59/592529_6_.png 425w"
                loading="lazy">
            </div>

        </div>
        <div v-if="!show_loading_page" class="form_wrapper">
            <div class="form_inner_wrapper">

                <div class="header_wrapper">
                    <h1>AD-FREE EXPERIENCE</h1>
                    <h2>{{page_subtitle}}</h2>
                    <h2 v-if="already_ad_free">{{already_ad_free_message}}</h2>
                </div>
                <div v-if="!already_ad_free" v-bind:class="{'long_form': !user_logged_in&&show_create_account_fields}" class="floating_form">
                    <span v-if="display_form_message">{{form_message}}</span>

                    <div class="input_wrapper">
                        <label for="coupon_code">Coupon</label>
                        <input v-model="coupon_code_input" id="coupon_code" type="text" placeholder="Insert your coupon code here">
                    </div>

                    <div v-if="!user_logged_in" class="input_wrapper">
                        <label for="email">Email </label>
                        <input v-model="email_input" id="email" type="email" placeholder="Insert your email here">
                        <input v-model="human" class="human" type="text" name="human" id="human" value=""> <!--real people should not fill this in and expect good things - do not remove this -->
                    </div>

                    <div v-if="!user_logged_in&&show_create_account_fields" class="input_wrapper">
                        <label for="name">Name</label>
                        <div class="input_inner_wrapper name">
                            <input v-model="name_input" id="name" type="text" placeholder="Name">
                            <input v-model="last_name_input" id="last_name" type="text" placeholder="Last Name">
                        </div>
                    </div>

                    <div v-if="!user_logged_in&&show_create_account_fields" class="input_wrapper password">
                        <label for="coupon_code">Password</label>
                        <input v-model="password_input" id="password" type="password" placeholder="Insert password here">
                    </div> 

                    <button v-if="!show_create_account_fields&&!submiting" :disabled="submiting" @click="apply_coupon()" class="submit_btn">Apply Coupon</button>

                    <button v-if="show_create_account_fields&&!submiting" :disabled="submiting" @click="create_account_and_apply_coupon()" class="submit_btn">Apply Coupon</button>
                    
                    <div v-if="submiting" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
                </div>
                
                <div v-if="already_ad_free" class="floating_form">
                    <button @click="redirect('/')" class="standard_btn">Go to Homepage</button>
                    <button @click="redirect('/articles/')" class="standard_btn">Read Our Articles</button>
                    <button @click="redirect('/daily_newsletters/')" class="standard_btn">Subscribe to Our Daily Newsletters</button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'coupons-page',
    data() {
        return {
            page_subtitle: 'Claim Your Coupon!',
            form_message: '',
            display_form_message: false,
            coupon_code_input: '',
            name_input: '',
            last_name_input: '',
            email_input: '',
            password_input: '',
            human: '',
            submiting: false,
            // show_congradulations: false,
            already_ad_free: false,
            already_ad_free_message: 'You own an Ad-Free subscription!',
            user_logged_in: false,
            show_create_account_fields: false,
            show_loading_page: true,
        }
    },
    methods: {

        apply_coupon() {
            this.submiting = true;

            if(readCookie('rcmg_guid') !== null && readCookie('rcmg_token') !== null) {

                if (this.coupon_code_input === '') {
                    this.form_message = 'Please insert a coupon code';
                    this.display_form_message = true;
                    this.submiting = false;
                } else {
                    this.form_message = '';
                    this.display_form_message = false;
                    this.loggedin_apply_coupon();
                }

            } else {

                if (this.coupon_code_input === '' || this.email_input === '') {
                    this.form_message = 'Please fill out all fields';
                    this.display_form_message = true;
                    this.submiting = false;
                } else {
                    this.apply_coupon_and_login();
                }

            }
        },

        apply_coupon_success( response) {

            rcmg_setLocalCookies(
                {
                guid: response.data.rcmg_guid,
                token: response.data.rcmg_token,
                username: response.data.rcmg_username,
                ev_ss: response.data.ev_ss,
                ex_ss: response.data.ex_ss,
                accu_weather_loc_key: response.data.accu_weather_loc_key,
                has_evaf: response.data.has_evaf,
                rcmg_newsletters: response.data.rcmg_newsletters,
                is_unsubscribed: response.data.is_unsubscribed,
                rcmg_product_type: response.data.rcmg_product_type,
                rcmg_liveramp: response.data.rcmg_liveramp,
                user_access: response.data.user_access,
                }, 
                true
            );
            this.form_message = 'Coupon Applied!';
            this.display_form_message = true;

        },

        apply_coupon_error( response ) {

            this.submiting = false;
            this.form_message = response.data.message;
            this.display_form_message = true;

            if(response.data.create_account === true) {
                this.show_create_account_fields = true;
            }


        },

        redirect( url ) {

            window.location.href = url;

        },

        loggedin_apply_coupon() {

            rcmg_api_call('get_user_info', {
                token: readCookie('rcmg_token'),
                guid: readCookie('rcmg_guid'),
                userAgent: navigator.userAgent,
            }, function(response) {

                if (response.success) {
                    this.email_input = response.data.user_email
                    this.apply_coupon_and_login();
                }

            }.bind(this));

        },

        apply_coupon_and_login() {

            rcmg_api_call('apply_coupon_and_login', {
                email: this.email_input,
                coupon_code: this.coupon_code_input,
                user_agent: navigator.userAgent,
                wurfl: navigator.wurfl,
                zelda: this.human
            }, function(response) {

                if (response.success) {
                    this.apply_coupon_success(response);
                } else {
                    this.apply_coupon_error(response);
                }

            }.bind(this));

        },

        create_account_and_apply_coupon() {

            this.submiting = true;
            const current_loc = window.location.pathname;
            rcmg_api_call('form_register', {
                user_email: this.email_input,
                user_password: this.password_input,
                user_password_again: this.password_input,
                user_name:  this.name_input + ' ' + this.last_name_input,
                user_first_name: this.name_input,
                user_last_name: this.last_name_input,
                redirect_to: 'https://' + location.host + current_loc,
                zelda: this.human,
                site: getDomain()
            }, function (response) {

                if (response.success) {

                    this.get_unconfirmed_user();

                } else {
                    this.form_message = response.messages[0].message;
                    this.display_form_message = true;
                    this.submiting = false;
                }

            }.bind(this));
        }, 

        management_api(method , $post_data, callback) {
            const url = '//util:F39zm5budLaLTxG6@util.realclearpolitics.com/rcmg_users_management_system/api.php';
            const now_time = new Date().getTime();
            $.ajax({
                type: "POST",
                url: window.location.protocol + url + "?cache_bust="+now_time+"&method="+method+"&jsoncallback=?",
                data: $post_data,
                success: callback
            });
        },

        get_unconfirmed_user() {
            this.management_api('search_form', {
                type: 'unconfirm',
                search: this.email_input,
            }, function(response) {
                if (response.data.success) {
                    this.confirm_user(response.data.response[0].unconfirmed_id);
                } else {
                    this.form_message = 'Error activating your account, please check your email and confirm your account';
                    this.display_form_message = true;
                    this.submiting = false;
                }
            }.bind(this));
        },

        confirm_user(user_id) {
            this.management_api('confirm_user', {
                user_id: user_id,
            }, function(response) {
                if (response.data.success) {
                    this.apply_coupon_and_login();
                } else {
                    this.form_message = 'Error activating your account, please check your email and confirm your account';
                    this.display_form_message = true;
                    this.submiting = false;
                }
            }.bind(this));
        }
        
    },
    mounted: function() {

        let counter = 0;
        const check_login = setInterval(function() {

            if(readCookie('evaf') !== null && readCookie('rcmg_guid') !== null && readCookie('rcmg_token') !== null) {
                this.already_ad_free = true;
                this.page_subtitle = 'Congratulations' + ' ' + readCookie('rcmg_username').replace(/\+/g, ' ') + '!';
                this.show_loading_page = false;
                clearInterval(check_login);
            } else if (readCookie('rcmg_guid') !== null && readCookie('rcmg_token') !== null) {
                this.user_logged_in = true;
                this.show_loading_page = false;
            } else {
                this.show_loading_page = false;
            }
            counter++;
            if (counter > 5) {
                clearInterval(check_login);
            }

        }.bind(this), 1000);

    },

}
</script>
